import React from 'react';
export function Logo() {
  return <div className="flex items-center" data-id="element-32">
      <div className="h-6 w-6 border-2 border-black rotate-45 mr-2" data-id="element-33"></div>
      <span className="text-xl font-medium" data-id="element-34">Altman</span>
    </div>;
}